import ChangeReducer from './ChangeReducer';
import C from './Constants';
import { produce } from 'immer';
import {patch,unpatch} from 'jsondiffpatch';
import DefaultHistoryInfo from './DefaultHistoryInfo';
import applyChangesToHistoryInfo from './applyChangesToHistoryInfo';
import getStateWithUpdatedChangeHistory from './getStateWithUpdatedChangeHistory';
import { isCLI } from './versionConfig';
import G from './Getters';

function removeReduxDevtoolsKeysFromRawAction(rawAction){
  let action = Object.fromEntries(Object.entries(rawAction).filter(([key,val]) => {
    return ['__loginInfo','__dialogsCount'].every(badKey => badKey !== key)
  }))
  return action;
}

export default function UndoRedoReducer(state,rawAction){

  let action = removeReduxDevtoolsKeysFromRawAction(rawAction);

  if( !state ){
    return ChangeReducer(state,action);
  }


  let { historyInfo } = state;
  let { activeHistory, index } = historyInfo;

  switch(action.type){

    case C.setState:{
      return action.state;
    }

    case C.UNDO:
    case C.REDO:{



      let changeArgMap = { 
        [C.UNDO]:{ patchFunction:unpatch, opIndexDelta:1, newIndexDelta: 1 },
        [C.REDO]:{ patchFunction:patch, opIndexDelta:0, newIndexDelta:-1 }
      }

      let {opIndexDelta, newIndexDelta} = changeArgMap[action.type];

      let newIndex = index+newIndexDelta;
      let changesAtEpoch = activeHistory[ index+opIndexDelta ];
      if( changesAtEpoch ){

        let {patchFunction} = changeArgMap[ action.type ];
        

        return applyChangesToHistoryInfo(
          state,
          patchFunction,
          changesAtEpoch,
          newIndex
        );
      }else{
        return state;
      }
      
      
    }
    case C.CLEAR_HISTORY:{
      return produce(state,draft => {
        draft.historyInfo = DefaultHistoryInfo();
      })
    }
    default:
      let update;

      try{

        //console.log("Tryingn for an update:" + action.type);
        update = getStateWithUpdatedChangeHistory(state,action);


      }catch(e){

        debugger;


        if( process.env.NODE_ENV !== "production" ){

          let stack = e.stack.split('\n').reverse().map(x => {
            return x.replace(/\/.*src\//,"").replace(/\/.*node_modules\//,"")
          }).join('\n');

          if( isCLI() ){

            debugger;
            //throw e;
            let str = stack + '\n' + e.toString().split("\n")

            console.red(str);

            return {
              __REDUCER_ERROR:str
            }
          }
        }

        console.log('\n\n\n')
        console.log("Action: " + action.type);
        console.log('\n\n\n')
        throw e;
      }

      if( action.type === "mergePersistedUserDataWithCurrentSessionData" ){
      debugger;
    }
      return update;
  }
}
